import { render, staticRenderFns } from "./SalesComponent.vue?vue&type=template&id=2e749e6f&scoped=true&"
import script from "./SalesComponent.vue?vue&type=script&lang=js&"
export * from "./SalesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e749e6f",
  null
  
)

export default component.exports